module.exports = __webpack_public_path__ + "media/images/cookie-0bb6f7b3a010e520076bb018e7ff9134.png";